import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';

/**
 * Formats a given date (string or Date object) into "M/D/Y h:mm a" format.
 *
 * @example output:
 * "3/19/2025 10:30 AM"
 */
export const getFormattedDateWithTimePeriodSuffix = (
  dateInput: string | Date,
): string => {
  const date = typeof dateInput === 'string' ? parseISO(dateInput) : dateInput;

  return format(date, 'M/d/y h:mm a');
};
